import { PLANNING_STATES } from "../../../classes/enums/PlanningStateEnum";
import ImageViewer from "../../../components/imageViewer/ImageViewer";
import RemoteViewer from "../../../components/remoteViewer/RemoteViewer";
import "./SliceViewer.css";

// Normalize view name to display settings key
const getDisplaySettingsViewType = viewName => {
  if (!viewName) return null;
  const lower = viewName.toLowerCase();
  if (lower.includes("sagittal") || lower.includes("lateral")) return "sagittal";
  if (lower.includes("coronal") || lower.includes("front")) return "coronal";
  if (lower.includes("axial")) return "axial";
  return null;
};

const SliceViewer = ({
  views,
  modality,
  handleImageClose,
  renderClient,
  isViewClosing,
  planId,
}) => {
  const renderSingleView = view => {
    return (
      <div
        className={`Check-${modality
          .toLowerCase()
          .replace("_", "-")}-grid single-view`}
      >
        <ImageViewer
          key={`image-container-${view.key}`}
          className={
            isViewClosing(view.viewData.viewId, view.instance._id, 0, modality)
              ? "Check-closing"
              : ""
          }
          viewData={view.viewData}
          instance={view.instance}
          onContentLoad={() => {}}
          onCameraClick={() => {}}
          onBrightnessClick={() => {}}
          step={PLANNING_STATES.CHECK}
          viewType={view.viewName}
          viewId={view.viewData.viewId}
          remoteRenderClient={renderClient}
          planId={planId || PLANNING_STATES.CHECK}
          instanceId={view.instance?._id}
          displaySettingsViewType={getDisplaySettingsViewType(view.viewName)}
          persistedDisplaySettings={
            view.instance?.display_settings?.[
              getDisplaySettingsViewType(view.viewName)
            ]
          }
        >
          <RemoteViewer
            remoteRenderClient={renderClient}
            viewData={view.viewData}
            sliderWidth="80%"
          />
        </ImageViewer>
      </div>
    );
  };

  const renderTwoColumn = views => {
    return (
      <div
        className={`Check-${modality
          .toLowerCase()
          .replace("_", "-")}-grid two-column`}
      >
        {views.map((view, index) => (
          <div key={`column-${index}`} className={`column-${index}`}>
            <ImageViewer
              key={`image-container-${view.key}`}
              className={
                isViewClosing(
                  view.viewData.viewId,
                  view.instance._id,
                  view.index,
                  modality
                )
                  ? "Check-closing"
                  : ""
              }
              viewData={view.viewData}
              instance={view.instance}
              onContentLoad={() => {}}
              onCameraClick={() => {}}
              onBrightnessClick={() => {}}
              step={PLANNING_STATES.CHECK}
              viewType={view.viewName}
              viewId={view.viewData.viewId}
              remoteRenderClient={renderClient}
              planId={planId || PLANNING_STATES.CHECK}
              instanceId={view.instance?._id}
              displaySettingsViewType={getDisplaySettingsViewType(view.viewName)}
              persistedDisplaySettings={
                view.instance?.display_settings?.[
                  getDisplaySettingsViewType(view.viewName)
                ]
              }
            >
              <RemoteViewer
                remoteRenderClient={renderClient}
                viewData={view.viewData}
                sliderWidth="80%"
              />
            </ImageViewer>
          </div>
        ))}
      </div>
    );
  };

  const renderMultiView = views => {
    return (
      <div
        className={`Check-${modality
          .toLowerCase()
          .replace("_", "-")}-grid multi-view`}
      >
        {/* First column - first view (takes full height) */}
        <div className="first-column">
          <ImageViewer
            key={`image-container-${views[0].key}`}
            className={
              isViewClosing(
                views[0].viewData.viewId,
                views[0].instance._id,
                0,
                modality
              )
                ? "Check-closing"
                : ""
            }
            viewData={views[0].viewData}
            instance={views[0].instance}
            onContentLoad={() => {}}
            onClose={() =>
              handleImageClose(
                views[0].instance._id,
                views[0].viewData.viewId,
                0,
                modality
              )
            }
            onCameraClick={() => {}}
            onBrightnessClick={() => {}}
            step={PLANNING_STATES.CHECK}
            viewType={views[0].viewName}
            viewId={views[0].viewData.viewId}
            remoteRenderClient={renderClient}
            planId={planId || PLANNING_STATES.CHECK}
            instanceId={views[0].instance?._id}
            displaySettingsViewType={getDisplaySettingsViewType(views[0].viewName)}
            persistedDisplaySettings={
              views[0].instance?.display_settings?.[
                getDisplaySettingsViewType(views[0].viewName)
              ]
            }
          >
            <RemoteViewer
              remoteRenderClient={renderClient}
              viewData={views[0].viewData}
              sliderWidth="80%"
            />
          </ImageViewer>
        </div>

        {/* Second column - contains remaining views stacked */}
        <div className="second-column">
          {views.slice(1).map(view => (
            <ImageViewer
              key={`image-container-${view.key}`}
              className={
                isViewClosing(
                  view.viewData.viewId,
                  view.instance._id,
                  view.index,
                  modality
                )
                  ? "Check-closing"
                  : ""
              }
              viewData={view.viewData}
              instance={view.instance}
              onContentLoad={() => {}}
              onCameraClick={() => {}}
              onBrightnessClick={() => {}}
              step={PLANNING_STATES.CHECK}
              viewType={view.viewName}
              viewId={view.viewData.viewId}
              remoteRenderClient={renderClient}
              planId={planId || PLANNING_STATES.CHECK}
              instanceId={view.instance?._id}
              displaySettingsViewType={getDisplaySettingsViewType(view.viewName)}
              persistedDisplaySettings={
                view.instance?.display_settings?.[
                  getDisplaySettingsViewType(view.viewName)
                ]
              }
            >
              <RemoteViewer
                remoteRenderClient={renderClient}
                viewData={view.viewData}
                sliderWidth="80%"
              />
            </ImageViewer>
          ))}
        </div>
      </div>
    );
  };

  // Determine layout based on number of views
  if (views.length === 1) {
    return renderSingleView(views[0]);
  } else if (views.length === 2) {
    return renderTwoColumn(views);
  } else {
    return renderMultiView(views);
  }
};

export default SliceViewer;
